import React from "react";
import { SectionHead } from "@/features/investors/components/atoms/InvestorsAtoms";
import { InsightItem, InvestorsInsights } from "@/features/investors/utils/investors-insights";

const Column: React.FC<{
    kind: "wins" | "risks" | "opps";
    icon: string;
    title: string;
    items: InsightItem[];
}> = ({ kind, icon, title, items }) => (
    <div className={`tk-col ${kind}`}>
        <h3>
            <span className="mso material-symbols-outlined">{icon}</span>
            {title}
        </h3>
        {items.length > 0 ? (
            items.map((item, index) => (
                <div key={item.title} className="tk-item">
                    <span className="n">{String(index + 1).padStart(2, "0")}</span>
                    <div>
                        <div className="t">{item.title}</div>
                        <div className="d">{item.detail}</div>
                    </div>
                </div>
            ))
        ) : (
            <div className="tk-item">
                <span className="n">—</span>
                <div className="d">Nothing flagged by the metrics this quarter.</div>
            </div>
        )}
    </div>
);

type Props = {
    insights: InvestorsInsights;
    nextQuarterLabel: string;
};

export const TakeawaysSection: React.FC<Props> = ({ insights, nextQuarterLabel }) => (
    <section className="sec" id="sec-takeaways">
        <SectionHead index="09" title="Investor takeaways" question="What the board should walk away with." />
        <div className="takeaways">
            <Column kind="wins" icon="military_tech" title="Wins" items={insights.wins} />
            <Column kind="risks" icon="warning" title="Risks" items={insights.risks} />
            <Column kind="opps" icon="rocket_launch" title="Opportunities" items={insights.opportunities} />
        </div>
        <div className="sec-head" style={{ borderTop: 0, paddingTop: 30, marginBottom: 0 }}>
            <span className="idx" style={{ visibility: "hidden" }}>
                ·
            </span>
            <div>
                <h2 style={{ fontSize: 18 }}>{nextQuarterLabel} priorities</h2>
                <div className="q">Where we invest next — derived from this quarter's metrics.</div>
            </div>
        </div>
        <div className="q2">
            {insights.priorities.map((priority) => (
                <div key={priority.index} className="q2-card">
                    <div className="n">{priority.index}</div>
                    <div className="t">{priority.title}</div>
                    <div className="d">{priority.detail}</div>
                </div>
            ))}
        </div>
    </section>
);
